/**
 * TaskPriorityService
 * Service for TaskPriority entity operations
 * Route: api/task-priority
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskPriorityService
 * Handles task priority CRUD operations
 */
export class TaskPriorityService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskPriorityService.DEFAULT_SERVICE_PATH,
            basePath: TaskPriorityService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
TaskPriorityService.DEFAULT_SERVICE_PATH = 'tasks';
TaskPriorityService.BASE_PATH = 'api/task-priority';
//# sourceMappingURL=TaskPriorityService.js.map